// The shared vocabulary of signals, German. It lives HERE and not in the page catalogue because
// SignalsZone is on the Person and Organisation pages too, and both must be able to say
// "Stellenwechsel" without importing the Signals page.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Signals': 'Signale',
  'every signal cites what it was read from': 'jedes Signal nennt, woraus es gelesen wurde',
  'loading…': 'wird geladen…',
  'The signals could not be read: {error}': 'Die Signale konnten nicht gelesen werden: {error}',
  'No monitor has raised anything for this subject. A signal is an observation with the snapshot, the publication or the snippet that proves it, and a suggested action. It never writes to the record: it proposes, and an operator holds or refuses it in Review.':
    'Für dieses Subjekt hat noch kein Monitor etwas gemeldet. Ein Signal ist eine Beobachtung mit dem Snapshot, der Publikation oder dem Auszug, der sie belegt, und einem Handlungsvorschlag. Es schreibt nie in den Datenbestand: Es schlägt vor, und die Operatorin übernimmt oder lehnt es in der Prüfung ab.',
  'Create task': 'Aufgabe erstellen',
  'Dismiss': 'Verwerfen',
  'Task {ref} created': 'Aufgabe {ref} erstellt',
  '{ref} dismissed': '{ref} verworfen',
  'Could not dispose of the signal.': 'Über das Signal konnte nicht entschieden werden.',

  // signal kinds
  'risk': 'Risiko',
  'budget': 'Budget',
  'board': 'Gremium',
  'move': 'Wechsel',
  'post': 'Beitrag',
  'tender': 'Ausschreibung',
  'mention': 'Erwähnung',
  'coverage': 'Abdeckung',

  // dispositions
  'task': 'Aufgabe',
  'draft': 'Entwurf',
  'dismissed': 'verworfen',

  // what the signal was read out of
  'snapshot': 'Snapshot',
  'publication': 'Publikation',
  'search': 'Suche',
  'surfe': 'Surfe',
  'manual': 'manuell',
  'computed': 'berechnet',

  // monitor kinds
  'website': 'Website',
  'careers': 'Stellen',
  'news': 'News',
  'shab': 'SHAB',
  'zefix': 'Zefix',
  'surfe_job': 'Surfe-Wechsel',
  'linkedin_manual': 'LinkedIn (manuell)',

  // monitor outcomes ('refused' comes from the shared vocabulary)
  'unchanged': 'unverändert',
  'changed': 'verändert',
  'signal': 'Signal',
  'error': 'Fehler',

  // why a refusal was a refusal
  'robots': 'robots.txt',
  'blocked_host': 'gesperrter Host',
  'no_credentials': 'keine Zugangsdaten',
  'manual_only': 'nur manuell',
  'no_linkedin_url': 'keine LinkedIn-URL',
}, 'SignalsZone');
